import { IDI_CUSTOMER_SEARCH_START_LOADING, IDI_CUSTOMER_SEARCH_END_LOADING, IDI_CUSTOMER_SEARCH_LOADED, SET_IDI_CUSTOMER_FILTER } from "../constants/IdiCustomerConstants";
import { IDI_CUSTOMER_START_LOADING, IDI_CUSTOMER_END_LOADING, IDI_CUSTOMER_LOADED } from "../constants/IdiCustomerConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiCustomerSearch(filters, type, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_CUSTOMER_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("IdiCustomer/GetPaged", filters[type], null);
            
            if(data.success) {
                await dispatch({
                    type: IDI_CUSTOMER_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_CUSTOMER_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_CUSTOMER_SEARCH_END_LOADING });
        }
    };
}

export function setIdiCustomerFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_CUSTOMER_FILTER,
            payload: filter
        });
    };
}

export function loadIdiCustomer(id, type, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_CUSTOMER_START_LOADING });

        try {

            var skipValidation = false;
            var data = await getApiData("IdiCustomer/GetIdiCustomerFBO", { id, type, skipValidation });
            
            if(data.success) {
                await dispatch({
                    type: IDI_CUSTOMER_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_CUSTOMER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_CUSTOMER_END_LOADING });
        }
    };
}

export function saveIdiCustomer(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_CUSTOMER_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var skipValidation = false;
            var data = await postApiJsonData("IdiCustomer/SaveIdiCustomerFBO", { skipValidation }, fbo);
            
            if(data.success) {
                if(isAdd) {
                    if(data.responseEntities[0].customer.isCustomer) {
                        navigate('/idi-customer-edit/' + data.responseEntities[0].customer.id);
                        dispatch(commonActions.setSuccessMessage("IDI Customer Created Successfully!"));
                    }
                    else if(data.responseEntities[0].customer.isOwner) {
                        navigate('/idi-customer-edit/' + data.responseEntities[0].customer.id);
                        dispatch(commonActions.setSuccessMessage("IDI Owner Created Successfully!"));
                    }
                }
                else {
                    await dispatch({
                        type: IDI_CUSTOMER_LOADED,
                        payload: data.responseEntities[0]
                    });

                    if(data.responseEntities[0].customer.isCustomer) {
                        dispatch(commonActions.setSuccessMessage("IDI Customer Saved Successfully!"));
                    }
                    else if(data.responseEntities[0].customer.isOwner) {
                        dispatch(commonActions.setSuccessMessage("IDI Owner Saved Successfully!"));
                    }
                }
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_CUSTOMER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_CUSTOMER_END_LOADING });
        }
    };
}

export async function loadIdiCustomerAsync(id, type) {
    var idiCustomerData = {
        fbo: null
        , error: null
    };

    try {

        var skipValidation = true;
        var data = await getApiData("IdiCustomer/GetIdiCustomerFBO", { id, type, skipValidation });
        
        if(data.success) {
            idiCustomerData.fbo= data.responseEntities[0];
        }
        else {
            idiCustomerData.error = data.errorDesc;
        }
    } 
    catch (error) {
        idiCustomerData.error = error;
    }

    return idiCustomerData;
}

export async function saveIdiCustomerAsync(fbo) {
    var idiCustomerData = {
        fbo: null
        , error: null
    };

    try {

        var skipValidation = true;
        var data = await postApiJsonData("IdiCustomer/SaveIdiCustomerFBO", { skipValidation }, fbo);
        
        if(data.success) {
            idiCustomerData.fbo= data.responseEntities[0];
        }
        else {
            idiCustomerData.error = data.errorDesc;
        }
    } 
    catch (error) {
        idiCustomerData.error = error;
    }

    return idiCustomerData;
}